import React from 'react'

import User from './components/User';
import TransactionHistory from './Transactions/transactionhistory';
import WithdrawTable from './components/WithdrawTable';
const Earnings = () => {
  return (
    <div>
     
      <div className="container dashboard-page mt-4 min-h">
        <User />
    <div className="">
        <TransactionHistory />
        <WithdrawTable />
        </div>
      </div>
    </div>
  )

}
export default Earnings